import { bindable, computedFrom } from 'aurelia-framework';
import moment from 'moment';

class SearchSection {
  @bindable loading = false;
  @bindable hasSettings = false;
  @bindable events = {};
  @bindable selectedEvent = null;
  @bindable onEventSelection = () => {};
  @bindable properties = [];
  @bindable typesByProperty = {};
  @bindable fieldsByProperty = {};
  @bindable rules = [];
  @bindable onNewRule = () => {};
  @bindable onRulePropertyChange = () => {};
  @bindable onRuleTypeChange = () => {};
  @bindable onRuleValueChange = () => {};
  @bindable onRuleDeleted = () => {};
  @bindable dateRange = null;
  @bindable defaultDateRange = null;
  @bindable onDateRangeChange = () => {};
  @bindable onSearch = () => {};
  @bindable hasMadeASearch = false;
  @bindable hasSearchSettingsChanged = true;
  @bindable showForm = true;
  @bindable onUpdateSearch = () => {};
  calendarOptions = {
    showMonths: 2,
    mode: 'range',
    enableTime: false,
    dateFormat: 'm/d/Y',
    allowInput: false,
    maxDate: new Date(),
  };
  _calendarInstance = null;
  _defaultDateRangeAsString = null;
  attached() {
    if (this.defaultDateRange) {
      this.calendarOptions.defaultDate = [
        this.defaultDateRange.from,
        this.defaultDateRange.to,
      ];
      this._defaultDateRangeAsString = {
        from: this.defaultDateRange.from.toString(),
        to: this.defaultDateRange.to.toString(),
      };
    }
  }
  addNewRule() {
    const [property] = this.availableProperties;
    const [type] = this.typesByProperty[property.id];
    this.onNewRule({
      rule: {
        property,
        type,
        value: '',
      },
    });
  }
  changeDateRange(selectedDates, dateStr, instance) {
    this._calendarInstance = instance;
    if (selectedDates.length > 1) {
      const [from, to] = selectedDates;
      this.onDateRangeChange({ from, to });
    }
  }
  caledarReady(selectedDates, dateStr, instance) {
    this._calendarInstance = instance;
    if (this.dateRange) {
      const { from, to } = this.dateRange;
      this._calendarInstance.setDate([from, to]);
    }
  }
  resetDateRange() {
    this._calendarInstance.clear();
    this._calendarInstance.close();
    const { from, to } = this.defaultDateRange;
    this._calendarInstance.setDate([from, to]);
    this.onDateRangeChange({ from, to });
  }
  search($event) {
    $event.preventDefault();
    this.onSearch();
  }
  @computedFrom('properties', 'rules')
  get availableProperties() {
    return this.properties
    .filter((property) => !this.rules.some((rule) => rule.property.id === property.id));
  }
  @computedFrom('rules')
  get propertiesForRule() {
    const availables = this.availableProperties;
    return this.rules.map((rule) => [
      rule.property,
      ...availables,
    ]);
  }
  @computedFrom('selectedEvent', 'rules', 'dateRange')
  get summary() {
    let result = '';
    if (this.selectedEvent) {
      const items = [`${this.selectedEvent.name} events`];

      if (this.dateRange) {
        const from = moment(this.dateRange.from).format('MMM Do YY');
        const to = moment(this.dateRange.to).format('MMM Do YY');
        items.push(`Between ${from} and ${to}`);
      }

      if (this.rules.length > 1) {
        items.push(`By ${this.rules.length} properties`);
      } else if (this.rules.length === 1) {
        const [firstRule] = this.rules;
        items.push(`By ${firstRule.type.name}`);
      }

      result = items.join(' - ');
    }

    return result;
  }
  @computedFrom('dateRange', '_defaultDateRangeAsString')
  get customDateRange() {
    let result = true;
    if (
      this.dateRange &&
      this._defaultDateRangeAsString &&
      this.dateRange.from &&
      this.dateRange.to &&
      this.dateRange.from.toString() === this._defaultDateRangeAsString.from &&
      this.dateRange.to.toString() === this._defaultDateRangeAsString.to
    ) {
      result = false;
    }

    return result;
  }
}

export { SearchSection };
